import { useEffect, useState } from "react";
import {
  MiButton,
  MiChip,
  MiDetailPageHeader,
  MiTab,
} from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { Box } from "@mui/material";
import { PLAN_TABS, PLAN_TAB_VALUES } from "../constants";
import { PlanCommunities } from "./PlanCommunities/PlanCommunities";
import { PlanSeries } from "./PlanSeries/PlanSeries";
import { usePlanDetailsViewModel } from "./usePlanDetailsViewModel";

export function PlanDetail() {
  const [openSeriesModal, setOpenSeriesModal] = useState(false);
  const [openSeriesGroupModal, setOpenSeriesGroupModal] = useState(false);

  const {
    params: { accountId, tab },
    navigate,
  } = useRouter();
  const {
    isLoading,
    stateManager,
    accountDetail,
    getAccountDetail,
    search,
    setSearch,
    debouncedSearch,
  } = usePlanDetailsViewModel();

  useEffect(() => {
    getAccountDetail(accountId);
  }, []);

  const renderActions = () => {
    if (tab === PLAN_TAB_VALUES.SERIES) {
      return (
        <Box display="flex" gap={2}>
          <MiButton
            title="Series Group"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            onClick={() => setOpenSeriesGroupModal(true)}
          />
          <MiButton
            title="Series"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            onClick={() => setOpenSeriesModal(true)}
          />
        </Box>
      );
    }
    return null;
  };

  return (
    <>
      <Box>
        <MiDetailPageHeader
          title={
            <Box display="flex" alignItems="center" gap={2}>
              {accountDetail.status && (
                <MiChip
                  color={
                    accountDetail.status === "Active" ? "success" : "error"
                  }
                  label={accountDetail.status}
                  sx={{ borderRadius: 1 }}
                />
              )}
              {accountDetail.name}
            </Box>
          }
          subTitles={[accountDetail.accountType]}
          customOnBack={() => navigate(`/estimating/old-bids`)}
          loading={isLoading}
          actionComponent={renderActions()}
          search={search}
          onHandleSearch={(e) => setSearch(e.target.value)}
          searchPlaceholder={
            tab === PLAN_TAB_VALUES.SERIES
              ? "Search Series"
              : "Search Communities"
          }
        />
        <MiTab
          tabs={PLAN_TABS}
          currentTab={tab}
          onTabChange={(tab) => {
            navigate(`/estimating/old-bids/${accountId}/${tab}`);
            setSearch("");
          }}
          borderBottom
        />
      </Box>
      {tab === PLAN_TAB_VALUES.SERIES && (
        <PlanSeries
          stateManager={stateManager}
          debouncedSearch={debouncedSearch}
          openSeriesGroupModal={openSeriesGroupModal}
          openSeriesModal={openSeriesModal}
          setOpenSeriesGroupModal={setOpenSeriesGroupModal}
          setOpenSeriesModal={setOpenSeriesModal}
        />
      )}
      {tab === PLAN_TAB_VALUES.COMMUNITIES && (
        <PlanCommunities
          stateManager={stateManager}
          debouncedSearch={debouncedSearch}
        />
      )}
    </>
  );
}
